import {useEffect} from 'react'
import styled from 'styled-components'

import ReactGA from 'react-ga4'
import {Navigate} from 'react-router-dom'
import LeftBar from '../home/components/leftBar'
import Trilha from './Trilha'

const Page = styled.div`
    display: flex;
    height: 100vh;
    /* mobile: 100dvh acompanha a barra de endereço do navegador */
    height: 100dvh;
    overflow: hidden !important;
`

export default function TrilhaGuru() {
    // Pageview uma vez por montagem: no corpo do componente, cada re-render
    // dispararia um hit repetido no GA. O effect vem ANTES do early-return
    // (regras de hooks) e repete o gate da flag por dentro — módulo desligado
    // redireciona sem o usuário ver a página, então não conta pageview.
    useEffect(() => {
        if (import.meta.env.VITE_TRILHA_GURU_ENABLED !== 'true') return
        ReactGA.send({
            hitType: 'pageview',
            page: '/trilha-guru',
            title: 'Trilha do Guru',
        })
    }, [])

    // Sem a flag exata 'true' no build, o módulo não existe no ambiente: a
    // rota redireciona (o item do menu também já não aparece). Estrita porque
    // env de Vite é string — por truthiness até 'false' habilitaria.
    if (import.meta.env.VITE_TRILHA_GURU_ENABLED !== 'true') {
        return <Navigate to="/" replace />
    }

    return (
        <Page>
            <LeftBar />
            <Trilha />
        </Page>
    )
}
